<template lang="pug">
f7-page#login
  navbar(title="ログイン")

  f7-toolbar.login-button-toolbar(bottom-md)
    large-button(
      title="ログイン"
      class="login-button"
      :disabled="!isValid"
      @click="onClickLogin"
    )

  background-image
    login-form(ref="form" v-model="isValid")
</template>

<style lang="scss" scoped>
.login-button-toolbar {
  height: 80px !important;
  background: none;

  .login-button {
    margin: 24px !important;
    width: 100%;
  }
}
</style>

<script>
import { mapGetters } from 'vuex'
import LoginForm from '@/components/organisms/LoginForm'
import LargeButton from '@/components/atoms/LargeButton'

export default {
  components: {
    LoginForm,
    LargeButton,
  },
  data() {
    return {
      isValid: false,
    }
  },
  computed: mapGetters('auth', ['currentUser', 'isLoggedIn']),
  methods: {
    async onClickLogin() {
      await this.$refs['form'].submit()

      if (!this.isLoggedIn || !this.currentUser.isCoach) {
        this.navigateToPublic()
        return
      }

      if (this.$f7route.query.originalUrl) {
        this.navigateToOriginal()
        return
      }

      this.navigateToStartPage()
    },
    navigateToPublic() {
      this.$f7router.navigate(
        { name: 'PublicRoot' },
        { clearPreviousHistory: true }
      )
    },
    navigateToOriginal() {
      this.$f7router.navigate(this.$f7route.query.originalUrl, {
        clearPreviousHistory: true,
      })
    },
    navigateToStartPage() {
      const param = this.findParameter('before')
      const pathName = param ? param : '/students'
      this.$f7router.navigate(pathName, {
        clearPreviousHistory: true,
        animate: false,
      })
    },
    findParameter(parameterName) {
      var result = null,
        tmp = []
      location.search
        .substr(1)
        .split('&')
        .forEach(function (item) {
          tmp = item.split('=')
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1])
        })
      return result
    },
  },
}
</script>
